import { render } from "./Podlove.vue?vue&type=template&id=b653c6e8"
import script from "./Podlove.vue?vue&type=script&lang=js"
export * from "./Podlove.vue?vue&type=script&lang=js"
script.render = render

export default script